(function () {
  'use strict';

  var playback = window.RabitatVideoPlayback;

  function playVideo(video) {
    if (!video) return;
    if (playback) {
      playback.safePlay(video);
      return;
    }

    video.muted = true;
    video.playsInline = true;
    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }
  }

  function pauseVideo(video) {
    if (playback) {
      playback.pauseVideo(video);
      return;
    }

    if (!video || video.tagName !== 'VIDEO') return;
    if (!video.paused) video.pause();
  }

  function warmVideo(video) {
    if (!video) return;
    if (playback) {
      playback.warmVideo(video);
      return;
    }

    if (video.preload === 'none') {
      video.preload = 'metadata';
      try {
        video.load();
      } catch (error) {}
    }
  }

  function isVideoVisible(video, scrollRoot) {
    var rect = video.getBoundingClientRect();
    if (rect.width <= 0 || rect.height <= 0) return false;

    if (scrollRoot) {
      var rootRect = scrollRoot.getBoundingClientRect();
      var overlapWidth = Math.min(rect.right, rootRect.right) - Math.max(rect.left, rootRect.left);
      var overlapHeight = Math.min(rect.bottom, rootRect.bottom) - Math.max(rect.top, rootRect.top);
      return overlapWidth > 0 && overlapHeight > 0;
    }

    var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

    return rect.right > 0 && rect.left < viewportWidth && rect.bottom > 0 && rect.top < viewportHeight;
  }

  function getCarouselSections() {
    return document.querySelectorAll('[data-rabitat-video-carousel]');
  }

  function getSectionVideos(section) {
    return Array.prototype.slice.call(
      section.querySelectorAll('.rabitat-video-gallery__video, .rabitat-video-showcase__video')
    );
  }

  function initGallery(section) {
    if (!section || section.dataset.rabitatVideoCarouselBound === 'true') return;

    var videos = getSectionVideos(section);
    if (!videos.length) return;

    section.dataset.rabitatVideoCarouselBound = 'true';

    var scrollRoot = section.querySelector('[data-collection-viewport]') || null;

    videos.forEach(function (video) {
      if (playback) playback.prepareVideo(video);
      warmVideo(video);
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target;
            if (entry.isIntersecting) {
              playVideo(video);
            } else {
              pauseVideo(video);
            }
          });
        },
        {
          root: scrollRoot,
          threshold: [0, 0.01, 0.1, 0.25, 0.5, 0.75],
          rootMargin: '0px 120px',
        }
      );

      videos.forEach(function (video) {
        observer.observe(video);
        if (isVideoVisible(video, scrollRoot)) {
          playVideo(video);
        }
      });
    } else {
      videos.forEach(playVideo);
    }

    section.addEventListener(
      'scroll',
      function () {
        videos.forEach(function (video) {
          if (isVideoVisible(video, scrollRoot)) {
            playVideo(video);
          }
        });
      },
      true
    );
  }

  function resumeVisibleVideos() {
    getCarouselSections().forEach(function (section) {
      var scrollRoot = section.querySelector('[data-collection-viewport]') || null;
      getSectionVideos(section).forEach(function (video) {
        if (isVideoVisible(video, scrollRoot)) {
          playVideo(video);
        }
      });
    });
  }

  function init() {
    getCarouselSections().forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section =
      event.target.querySelector('[data-rabitat-video-carousel]') ||
      event.target.closest('[data-rabitat-video-carousel]');
    if (section) {
      delete section.dataset.rabitatVideoCarouselBound;
      initGallery(section);
    }
  });

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      getCarouselSections().forEach(function (section) {
        getSectionVideos(section).forEach(pauseVideo);
      });
      return;
    }

    resumeVisibleVideos();
  });

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      resumeVisibleVideos();
    }
  });
})();
